import { hasAnalyticsConsent } from "./consent";

const MEASUREMENT_ID = "G-ZRD701HGE3";
const GA_COOKIE = /^_(ga|gid|gat)/;

let tagRequested = false;

/**
 * Inject gtag.js.
 *
 * The tag is deliberately absent from index.html and only ever reaches the
 * page from behind a consent check, so a visitor who has not accepted never
 * contacts Google at all — no request, no cookie, no IP disclosure.
 */
function ensureTagLoaded() {
  if (tagRequested) return;
  tagRequested = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };

  window.gtag("js", new Date());
  // send_page_view is off because this is a single-page app: trackPageView
  // reports every view, including the first.
  window.gtag("config", MEASUREMENT_ID, { send_page_view: false });

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(script);
}

/**
 * Report a page view, if — and only if — analytics consent has been given.
 * Guarding here rather than at the call site means no caller can leak a hit.
 */
export function trackPageView(path) {
  if (!hasAnalyticsConsent()) return;

  ensureTagLoaded();
  window[`ga-disable-${MEASUREMENT_ID}`] = false;

  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
    send_to: MEASUREMENT_ID,
  });
}

/**
 * Honour a withdrawal: stop a tag that is already on the page from sending
 * anything further, and remove the cookies it set.
 */
export function disableAnalytics() {
  window[`ga-disable-${MEASUREMENT_ID}`] = true;
  clearAnalyticsCookies();
}

function clearAnalyticsCookies() {
  const { hostname } = window.location;
  const domains = [undefined, hostname, `.${hostname}`];

  // GA sets its cookies on the registrable domain, which is one level up from
  // the host we are served on (www.telcofy.ai -> .telcofy.ai).
  const labels = hostname.split(".");
  if (labels.length > 2) {
    const registrable = labels.slice(-2).join(".");
    domains.push(registrable, `.${registrable}`);
  }

  document.cookie
    .split(";")
    .map((cookie) => cookie.split("=")[0].trim())
    .filter((name) => GA_COOKIE.test(name))
    .forEach((name) => {
      domains.forEach((domain) => {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${
          domain ? `; domain=${domain}` : ""
        }`;
      });
    });
}
